<template>
  <div
    v-if="routes.length"
    class="sidebar"
  >
    <ul class="sidebar__list ma-0 pa-0">
      <template v-for="(route, index) in routes">
        <li
          :key="index"
          class="sidebar__item mb-2"
        >
          <a
            :href="route.path"
            :class="[
              'sidebar__link text-body-1 text--text d-flex align-items-center text-decoration-none px-2 py-2 rounded',
              { 'sidebar__link_active font-weight-600': isActive(route) },
              { 'primary--text': isActive(route) },
            ]"
          >
            <v-icon
              v-if="route.icon"
              class="icon-secondary--text mr-4"
              size="20"
            >
              {{ route.icon }}
            </v-icon>
            {{ t(route.label, options) }}
          </a>
          <div
            v-if="route.items?.length"
            class="sidebar__list-inner mt-1 ml-4 d-flex flex-column gc-1"
          >
            <a
              v-for="item in route.items"
              :key="item.href"
              :href="item.href"
              class="sidebar__item-inner text-body-2 text-secondary--text d-flex align-items-center text-decoration-none"
            >
              <v-icon
                class="icon-secondary--text mr-1"
                size="20"
              >
                ui-icon-arrow-right
              </v-icon>
              {{ t(item.label, options) }}
            </a>
          </div>
        </li>
      </template>
    </ul>
  </div>
</template>

<script setup lang="ts">
import I18NextVue from 'i18next'
import { SidebarRoute } from 'src/types/info'

const props = defineProps<{
  path: string
  routes: SidebarRoute[]
}>()

const { t, language } = I18NextVue
const options = { ns: language }

const isActive = (route: SidebarRoute) => props.path === route.path
</script>

<style scoped lang="scss">
@import '~www/themes/doctors/common/variables';

.sidebar {
  &__list {
    list-style: none;
  }

  &__item {
    &:last-child {
      margin-bottom: 0;
    }
  }

  &__link {
    transition: background-color 0.2s ease, color 0.2s ease;

    &:hover {
      background-color: $ui-kit-bg-primary;
    }

    &.sidebar__link_active.primary--text {
      background-color: $ui-kit-bg-primary;
      color: $ui-kit-primary;
    }
  }
}
</style>
